export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20toned%20fashion%20lifestyle%20scene%20with%20neutral%20colored%20clothing%20items%20and%20minimalist%20accessories%20laid%20out%20on%20a%20light%20linen%20surface%2C%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20cozy%20clean%20aesthetic%2C%20cream%20and%20beige%20tones%20with%20warm%20undertones%2C%20editorial%20lifestyle%20photography%2C%20organic%20textures&width=1600&height=900&seq=cta-bg-2026&orientation=landscape"
        alt="Get your CSSBuy spreadsheet - access curated shopping agent resources and verified seller directories"
        title="CSSBuy Sheet Resources - Start Shopping with Confidence"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 tracking-wide">
          GET YOUR CSSBUY SHEET
        </h2>
        <p className="text-base md:text-lg text-background-50/85 mb-10 leading-relaxed">
          Browse verified seller spreadsheets and start shopping with confidence today. Every link curated and updated for accuracy.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          <div className="w-7 h-7 rounded-full bg-accent-400 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </div>
          BUY IT NOW
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}